<div class="confirm-dialog">
  <h2 mat-dialog-title>Reject permissions</h2>
  <div class="inner">
    <button
      [mat-dialog-close]="false"
      aria-label="Close"
      class="dialog__close-btn close-button"
    >
      <i class="fa fa-times">close</i>
    </button>
    <div
      mat-dialog-content
      [align]="'center'"
      style="white-space: pre-line; line-height: 30px"
    >
      <textarea
        class="form-control mb-4 ng-untouched ng-pristine ng-valid"
        name="permissionRejectReason"
        [(ngModel)]="permissionRejectReason"
        placeholder="provide a reason in order to reject the user requested permissions *"
      ></textarea>
    </div>
    <div mat-dialog-actions [align]="'end'" class="btn-group">
      <button
        class="btn btn-secondary"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="!permissionRejectReason?.trim()"
      >
        Submit
      </button>
    </div>
  </div>
</div>
<div class="overlay"></div>